import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ParkingLotPageComponent } from "@onsip/web/features/administrators/parkingLot/parkingLotPage/parking-lot-page.component";
import { ParkingLotSetupComponent } from "@onsip/web/features/administrators/parkingLot/parkingLotSetup/parking-lot-setup.component";

const routes: Routes = [
  {
    path: "",
    runGuardsAndResolvers: "always",
    data: { title: "Parking lot" },
    pathMatch: "full",
    component: ParkingLotPageComponent
  },
  {
    path: "add",
    runGuardsAndResolvers: "always",
    data: { title: "Setup parking lot" },
    pathMatch: "full",
    component: ParkingLotSetupComponent
  }
];
@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)]
})
export class ParkingLotRoutingModule {}
